<div class="max-w-1xl mx-auto bg-white p-8 rounded-lg shadow-lg">
  <div class="flex flex-row justify-between items-center mb-3">
    <div class="flex flex-row md:gap-3 items-center">
      <div class="flex flex-row flex-nowrap md:gap-3 items-center">
        <h1 class="headeradminui-text md:break-keep">Manage Forums</h1>
      </div>
      <div>
        <img
          class="separator"
          src="../../../../assets/icons/separator.svg"
          alt="img"
        />
      </div>
      <div>
        <!-- <h1 class="sub-headeradminui-text">{{ totalCount }} Events</h1> -->
        <h1 class="sub-headeradminui-text">{{ totalRecords }} Forums</h1>
      </div>
    </div>
    <button [routerLink]="['/events/forums/crud']" nz-button nzType="primary">
      Add Forums
    </button>
  </div>

  <nz-spin [nzSpinning]="tableLoading" nzTip="Fetching Forums....">
    <div nz-row>
      <nz-tabset
        (nzSelectChange)="tabChange($event)"
        [nzSelectedIndex]="selectedTab"
      >
        <nz-tab nzTitle="Upcoming Forums">
          <app-forum-table
            #UpcomingTableComponent
            [forumTableData]="data"
            [forumTotalPages]="totalRecords"
            [pageNum]="page"
            [pageSize]="pageSize"
            (resetFilterEvent)="resetFilter()"
            (pageChangeEvent)="onPageIndexChange($event)"
            (pageSizeChangeEvent)="onPageSizeChange($event)"
            (categoryFilterEvent)="categoryFilter($event)"
            (eventsDateFilterEvent)="dateFilter($event)"
            (paymentTypeFilterEvent)="paymentTypeFilter($event)"
            (hideTestFilterEvent)="testFilter($event)"
            (presenterFilterEvent)="presenterFilter($event)"
            (activeFilterEvent)="activeFilter($event)"
            (searchEvent)="searchGlobal($event)"
            [hideTestEvent]="hideTestEvent"
          ></app-forum-table>
        </nz-tab>
        <nz-tab nzTitle="Ongoing Forums">
          <app-forum-table
            #OngoingForumsComponent
            [forumTableData]="data"
            [forumTotalPages]="totalRecords"
            [pageNum]="page"
            [pageSize]="pageSize"
            (resetFilterEvent)="resetFilter()"
            (pageChangeEvent)="onPageIndexChange($event)"
            (pageSizeChangeEvent)="onPageSizeChange($event)"
            (categoryFilterEvent)="categoryFilter($event)"
            (eventsDateFilterEvent)="dateFilter($event)"
            (paymentTypeFilterEvent)="paymentTypeFilter($event)"
            (hideTestFilterEvent)="testFilter($event)"
            (presenterFilterEvent)="presenterFilter($event)"
            (activeFilterEvent)="activeFilter($event)"
            (searchEvent)="searchGlobal($event)"
            [hideTestEvent]="hideTestEvent"
          ></app-forum-table>
        </nz-tab>
        <nz-tab nzTitle="All Forums">
          <app-forum-table
            #AllTableComponent
            [forumTableData]="data"
            [forumTotalPages]="totalRecords"
            [pageNum]="page"
            [pageSize]="pageSize"
            (resetFilterEvent)="resetFilter()"
            (pageChangeEvent)="onPageIndexChange($event)"
            (pageSizeChangeEvent)="onPageSizeChange($event)"
            (categoryFilterEvent)="categoryFilter($event)"
            (eventsDateFilterEvent)="dateFilter($event)"
            (paymentTypeFilterEvent)="paymentTypeFilter($event)"
            (hideTestFilterEvent)="testFilter($event)"
            (presenterFilterEvent)="presenterFilter($event)"
            (activeFilterEvent)="activeFilter($event)"
            (searchEvent)="searchGlobal($event)"
            [hideTestEvent]="hideTestEvent"
          ></app-forum-table>
        </nz-tab>
      </nz-tabset>
    </div>
  </nz-spin>
</div>
